import React, { Suspense } from "react";

// UI components
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Container, Card } from "react-bootstrap";

/**
 * Simple page to display visual feedback that SSO Log In has succeeded before the pop-up/page closes
 */

export default function SSOSuccess() {
  return (
    <Suspense fallback={null}>
      <Container data-testid="sign-in">
        <Row className="justify-content-md-center align-items-center" style={{ height: "90vh" }}>
          <Col md={8} xl={6}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faCheck} size="3x" color="green" />

                <Card.Title>Success!</Card.Title>
              </Card.Body>

              <Card.Body className="text-muted">
                <Card.Text>Please wait while we log you in...</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Suspense>
  );
}
